module.exports = __webpack_public_path__ + "img/puberty-decal-11.328e5d0a.png";